import type { ReactElement } from 'react';
import { PaymentService } from 'config';
import Braintree from 'services/Braintree';
import type { OnToken } from 'services/Braintree';

type Props = {
  show: boolean;
  standalone?: boolean;
  onToken: OnToken;
};

function ApplePayProvider({
  show,
  onToken,
  standalone = false,
}: Props): ReactElement {
  // @ts-expect-error TODO: fix null safety
  return show && (
    standalone ? (
      <div>
        <button
          id="payment-method-apple-pay"
          type="button"
          aria-label="Apple Pay"
          className="apple-pay-button apple-pay-button-black"
          onClick={() => {
            Braintree.triggerApplePay((token, address) => (
              onToken(PaymentService.APPLE_PAY, token, address)
            ));
          }}
        />
      </div>
    ) : (
      <div
        className={[
          'c-payment-form__body',
          'c-payment-form__body--apple-pay',
          'collapse',
          'show',
        ].join(' ')}
      >
        <div className="c-alternative-payment-buttons">
          <div>
            <button
              id="payment-method-apple-pay"
              type="button"
              aria-label="Apple Pay"
              className="apple-pay-button apple-pay-button-black"
              onClick={() => {
                Braintree.triggerApplePay((token, address) => (
                  onToken(PaymentService.APPLE_PAY, token, address)
                ));
              }}
            />
          </div>
        </div>
      </div>
    )
  );
}

export default ApplePayProvider;
